import storage from "store2";

import DashboardApi from "../../api/DashboardApi";

const user = storage.get('user', {});

const isUserAuthed = DashboardApi.isLoggedIn() && Object.keys(user).length;
const initialPermissions = DashboardApi.getUserPermissions();
const initialForgotResetState = {
    loading: false,
    error: undefined,
    success: undefined
}

const initialState = {
    error: undefined,
    loading: false,
    authed: isUserAuthed,
    admins: [],
    forgotPassword: Object.assign({}, initialForgotResetState),
    resetPassword: Object.assign({}, initialForgotResetState),
    name: user.name,
    email: user.email,
    permissions: initialPermissions
};

export default function UserReducer(state = initialState, action) {
    switch (action.type) {
        case userActions.login:
            return {
                ...state,
                authed: true,
                ...action.data
            };
        case userActions.logout:
            return {
                ...state,
                authed: false,
                forgotPassword: Object.assign({}, initialForgotResetState),
                resetPassword: Object.assign({}, initialForgotResetState),
            };
        case userActions.updateAdminsList:
            return {
                ...state,
                admins: Object.assign([], action.data)
            };
        case userActions.updateForgotPwd:
            return {
                ...state,
                forgotPassword: {
                    ...state.forgotPassword,
                    ...action.data
                }
            };
        case userActions.updateResetPwd:
            return {
                ...state,
                resetPassword: {
                    ...state.resetPassword,
                    ...action.data,
                }
            };
        case userActions.loading:
            return {
                ...state,
                loading: action.data
            };
        case userActions.error:
            return {
                ...state,
                loading: false,
                error: typeof action.data === 'string'? action.data : JSON.stringify(action.data)
            };
        case userActions.clean:
            return {
                ...state,
                loading: false,
                error: null
            }
    
        default:
            return state;
    }
}

export const userActions = {
    loading: "user/LOADING",
    login: "user/LOGIN",
    logout: "user/LOGOUT",
    
    updateForgotPwd: "user/UPDATE_FORGOT_PWD",
    updateResetPwd: "user/UPDATE_RESET_PWD",

    updateAdminsList: "user/UPDATE_ADMINS_LIST",

    error: "user/ERROR",
    clean: "user/CLEAN_UP"
}